<template>
  <b-form class="form-signin">
    <img class="mb-4" src="/images/logo_veins.png" alt style="width: 19em" />
    <h1 class="h4 mb-3 font-weight-normal">Por favor, informe os dados</h1>

    <error-container v-bind:errors="viewData.errors || []" />

    <b-form-group>
      <label for="inputEmail" class="sr-only">Email</label>
      <b-input
        v-on:keyup.enter="save"
        :state="isOk('email')"
        v-model="state.email"
        placeholder="Email"
        autofocus
        required
      />
      <b-form-invalid-feedback style="text-align:left">{{
        getError('email')
      }}</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group>
      <label for="inputPassword" class="sr-only">Senha</label>
      <b-input
        :state="isOk('password')"
        v-model="state.password"
        type="password"
        placeholder="Senha"
        v-on:keyup.enter="save"
        required
      />
      <b-form-invalid-feedback style="text-align:left">{{
        getError('password')
      }}</b-form-invalid-feedback>
    </b-form-group>
    <button
      type="button"
      v-bind:disabled="viewData.loading"
      class="btn btn-primary btn-lg btn-block mb-3"
      v-on:click="save"
    >
      <b-icon
        v-if="viewData.loading"
        icon="three-dots"
        animation="cylon"
      ></b-icon>
      <span v-else>Entrar</span>
    </button>

    <p>
      <a href="/#/forgot">Esqueci minha senha</a>
    </p>
  </b-form>
</template>

<script>
import { Auth } from '../vue/auth';
import { Api } from '../vue/api';
import helpers from '../vue/helpers';

const API = new Api();

export default {
  name: 'login',
  data: function() {
    return {
      state: {
        email: '',
        password: '',
      },
      viewData: {
        loading: false,
        errors: [],
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    const hasSession = await Auth.hasSession();
    if (hasSession) {
      this.$router.push('/');
    }
  },
  methods: {
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },

    async save() {
      try {
        this.viewData.loading = true;
        const result = await API.post('/login', this.state);

        window.location.href = '/';
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }

      this.viewData.loading = false;
    },
  },
  components: {},
};
</script>
